import type { RewardPool, RewardPoolLeaderboardUser } from '@shared/api/types/rewardPools';
import { concatCurrencyToAmount } from '@shared/helpers/web3/formatters';

import { getWinningEntries } from '@store:web/components/entities/rewardPool';

type Props = {
  user: RewardPoolLeaderboardUser;
  rewardPool: RewardPool;
};

export const RewardList = ({ user, rewardPool }: Props) => {
  return (
    <div className="flex flex-col text-caption-sm-mono-a">
      {getWinningEntries(user?.entries).map((entry) => {
        const value = concatCurrencyToAmount(entry.reward ?? 0, rewardPool.reward_currency, {
          stableToDollar: false,
        });
        return (
          <div className="whitespace-nowrap" key={entry.id}>
            {value}
          </div>
        );
      })}
    </div>
  );
};
